import React, { Component } from 'react';
import CardList from '../components/CardList';
import Scroll from '../components/Scroll';
import SearchBox from '../components/SearchBox';
import DropdownBox from '../components/DropdownBox';
import logo from './logo-small.png';
import './App.css';

class App extends Component {
    constructor() {
        super()
        this.state = {
            games: [],
            searchfield: '',
            loading: true
        }
    }

    componentDidMount() {
        let url = "https://api.rawg.io/api/games?key=20ecfaa46746473eb3fef48fe853ff5e&dates=2020-01-01,2020-12-31&ordering=released&ordering=metactitic&stores=1";
        fetch(url, {
        method: "GET",
        withCredentials: true,
        headers: {
            "Content-Type": "application/json"
        }
        })
        .then(resp => resp.json())
        .then(data => {
            this.setState({ games: data.results, loading: false})
        })
        .catch(function(error) {
            console.log(error);
        });
    }

    onSearchChange= (event) => {
        this.setState({searchfield: event.target.value})
    }

    onSortChange= (event) => {
        let url = "https://api.rawg.io/api/games?key=20ecfaa46746473eb3fef48fe853ff5e&dates=2020-01-01,2020-12-31&ordering=released&ordering=metactitic&stores=1";
        
        if(event.target.value === 'rating') {
            url = "https://api.rawg.io/api/games?key=20ecfaa46746473eb3fef48fe853ff5e&dates=2020-01-01,2020-12-31&ordering=-rating&stores=1"
        } else if (event.target.value === 'upcoming') {
            url = "https://api.rawg.io/api/games?key=20ecfaa46746473eb3fef48fe853ff5e&dates=2021-01-01,2021-12-31&ordering=-added&stores=1"
        }

        this.setState({loading: true})

        fetch(url, {
            method: "GET",
            withCredentials: true,
            headers: {
                "Content-Type": "application/json"
            }
            })
            .then(resp => resp.json())
            .then(data => {
                this.setState({ games: data.results, loading: false})
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    render() {
        const filteredGames = this.state.games.filter(games => {
            return games.name.toLowerCase().includes(this.state.searchfield.toLowerCase());
        })
        if (!this.state.games.length) {
            return <h1 className='tc'>Loading...</h1>
        } else {
            return (
                <div className="tc">
                    <p><a href='index.html'><img src={logo} alt="logo" width="79" height="55" /> </a></p>
                    <h2>Top PC Steam Games of 2020</h2>
                    <div style={{ paddingBottom: '15px'}}>
                        <SearchBox searchChange={this.onSearchChange}/>
                        <DropdownBox sortChange={this.onSortChange} />
                    </div>
                    
                        <Scroll>
                        {this.state.loading ? <h1 className='tc'>Loading...</h1> : <CardList games={filteredGames} /> }
                        </Scroll>
                </div>
            );
        }
    }
}

export default App;